import React from 'react'
import EmailIcon from '@mui/icons-material/Email'
import ContactPageIcon from '@mui/icons-material/ContactPage'
import PhoneIcon from '@mui/icons-material/Phone'
import HomeIcon from '@mui/icons-material/Home'
import LocationCityIcon from '@mui/icons-material/LocationCity'
import FlagIcon from '@mui/icons-material/Flag'
import NumbersIcon from '@mui/icons-material/Numbers'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import {
  TextMaskCreditCard,
  TextMaskCreditCardDate,
  TextMaskPhoneNumber,
  TextMaskZipcode,
} from '../../components/maskedInputs'

export type ProfileFormInputType = {
  value: string
  label: string
  md: number
  lg: number
  regex: RegExp | undefined
  icon: React.ReactNode
  helperText?: string
  inputComponent?: React.ReactNode
}

export const ProfileFormInputs: Array<ProfileFormInputType> = [
  {
    value: 'firstName',
    label: 'First Name',
    regex: undefined,
    icon: <ContactPageIcon />,
    md: 6,
    lg: 3,
  },
  {
    value: 'lastName',
    label: 'Last Name',
    regex: undefined,
    icon: <ContactPageIcon />,
    md: 6,
    lg: 3,
  },
  {
    value: 'email',
    label: 'Email',
    regex: undefined,
    icon: <EmailIcon />,
    md: 6,
    lg: 3,
  },
  {
    value: 'phoneNumber',
    label: 'Phone Number',
    regex: undefined,
    icon: <PhoneIcon />,
    md: 6,
    lg: 3,
    inputComponent: TextMaskPhoneNumber as any,
  },
  {
    value: 'address',
    label: 'Address',
    regex: undefined,
    icon: <HomeIcon />,
    md: 6,
    lg: 6,
  },
  {
    value: 'city',
    label: 'City',
    regex: undefined,
    icon: <LocationCityIcon />,
    md: 6,
    lg: 2,
  },
  {
    value: 'state',
    label: 'State',
    regex: undefined,
    icon: <FlagIcon />,
    md: 6,
    lg: 2,
  },
  {
    value: 'zip',
    label: 'Zipcode',
    regex: undefined,
    icon: <NumbersIcon />,
    md: 6,
    lg: 2,
    inputComponent: TextMaskZipcode as any,
  },
  {
    value: 'cardNumber',
    label: 'Credit Card Number',
    regex: undefined,
    icon: <CreditCardIcon />,
    md: 6,
    lg: 6,
    inputComponent: TextMaskCreditCard as any,
  },
  {
    value: 'expirationDate',
    label: 'Credit Card Expiration Date',
    regex: undefined,
    icon: <CalendarMonthIcon />,
    md: 6,
    lg: 3,
    inputComponent: TextMaskCreditCardDate as any,
  },
  {
    value: 'cardCode',
    label: 'Credit Card CCV',
    regex: undefined,
    icon: <NumbersIcon />,
    md: 6,
    lg: 3,
  },
  {
    value: 'accountType',
    label: 'accountType',
    regex: undefined,
    icon: undefined,
    md: 12,
    lg: 12,
  },
  {
    value: 'nameOnAccount',
    label: 'Name on Account',
    regex: undefined,
    icon: <ContactPageIcon />,
    md: 6,
    lg: 3,
  },
  {
    value: 'accountNumber',
    label: 'Account Number',
    regex: undefined,
    icon: <NumbersIcon />,
    md: 6,
    lg: 3,
  },
  {
    value: 'accountNumberConfirm',
    label: 'Confirm Account Number',
    regex: undefined,
    icon: <NumbersIcon />,
    md: 6,
    lg: 3,
  },
  {
    value: 'routingNumber',
    label: 'Routing Number',
    regex: undefined,
    icon: <NumbersIcon />,
    md: 6,
    lg: 3,
  },
]

export const getProfileFormInputs = (isAchDebit: boolean) => {
  if (isAchDebit) {
    return ProfileFormInputs.filter(
      (x) =>
        x.value !== 'cardNumber' &&
        x.value !== 'expirationDate' &&
        x.value !== 'cardCode'
    )
  }
  return ProfileFormInputs.filter(
    (x) =>
      x.value !== 'accountNumber' &&
      x.value !== 'routingNumber' &&
      x.value !== 'nameOnAccount' &&
      x.value !== 'accountNumberConfirm' &&
      x.value !== 'accountType'
  )
}
